var React = require('react');

function SomethingWentWrong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33 63c16.569 0 30-13.431 30-30C63 16.431 49.569 3 33 3 16.431 3 3 16.431 3 33c0 16.569 13.431 30 30 30zm0 3C14.775 66 0 51.225 0 33S14.775 0 33 0s33 14.775 33 33-14.775 33-33 33zM21.64 32.459a3.246 3.246 0 110-6.492 3.246 3.246 0 010 6.492zm21.639 0a3.246 3.246 0 110-6.492 3.246 3.246 0 010 6.492zm.278 10.033a12.076 12.076 0 00-11.121 7.375c-.224.566-.355.983-.392 1.251-.013.003-.722.003-2.129 0 1.535-6.105 7.06-10.626 13.642-10.626 1.955 0 3.817.399 5.51 1.12l-1.023 1.808c-1.064-.454-3.467-.928-4.487-.928z","fill":"#333","fillRule":"nonzero","id":"wrong","stroke":"none","strokeWidth":"1"}));
}

SomethingWentWrong.defaultProps = {"width":"66","height":"66","viewBox":"0 0 66 66"};

module.exports = SomethingWentWrong;

SomethingWentWrong.default = SomethingWentWrong;
